module.exports = __webpack_public_path__ + "img/full3-min.c3dc536b.png";